<div fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="center center" data-cy="iot-platform-ui-filter-dropdown-field">
  <iot-platform-ui-form-group [fields]="fields()" [group]="form" />

  @if (requiresValue()) {
    @if (isAutocomplete()) {
      @if (isMultiSelect()) {
        <iot-platform-ui-async-autocomplete-multiple-selects
          (selectionChanged)="handleSelectionChange($event)"
          [clearOnSelect]="true"
          [currentFilters]="currentFilters()"
          [criteriaKey]="$safeNavigationMigration(fieldOptions()?.criteriaKey)"
          [data]="items()"
          [displayKey]="$safeNavigationMigration(fieldOptions()?.selectByProperty)"
          [displaySearchIcon]="false"
          [displayWrapper]="$safeNavigationMigration(fieldOptions()?.displayWrapper)"
          [filterKey]="fieldOptions()?.skipAutoCompleteFilterCriteria ? null : $safeNavigationMigration(fieldOptions()?.selectByProperty)"
          [filterBy]="$safeNavigationMigration(fieldOptions()?.filterBy)"
          [minLength]="1"
          [multiSelect]="true"
          [placeholder]="$safeNavigationMigration(fieldOptions()?.placeholder)"
          [showSpinner]="isLoading()"
          [disabled]="disabled()"
          [tooltip]="$safeNavigationMigration(fieldOptions()?.tooltip)"
          [disableOnlyOptions]="true"
          [emitMultipleValues]="true"
        />
      } @else {
        <iot-platform-ui-async-autocomplete
          [clearOnSelect]="true"
          (selectionChanged)="handleSelectionChange($event)"
          [data]="items()"
          [displayKey]="$safeNavigationMigration(fieldOptions()?.selectByProperty)"
          [displaySearchIcon]="false"
          [displayWrapper]="$safeNavigationMigration(fieldOptions()?.displayWrapper)"
          [filterKey]="fieldOptions()?.skipAutoCompleteFilterCriteria ? null : $safeNavigationMigration(fieldOptions()?.selectByProperty)"
          [filterBy]="$safeNavigationMigration(fieldOptions()?.filterBy)"
          [minLength]="1"
          [placeholder]="$safeNavigationMigration(fieldOptions()?.placeholder)"
          [showSpinner]="isLoading()"
          [tooltip]="$safeNavigationMigration(fieldOptions()?.tooltip)"
          [disabled]="disabled()"
        />
      }
    }
  }
</div>
